import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../actions/root_url';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isSY = ROOT_API_URL === 'https://sunny-scm.truckxi.com/api/';

const { Selectors } = Data;

export class SplitTrackingNumberModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},

            trackString: "",
        }
    }

    componentDidMount() {
        if (isAFG) {
            this.props.fetchShippingWeightTracking(this.props.salesOrderId).then((response) => {
                if (response.data) {
                    this.initializeModal(response.data);
                }
            }, (err) => {
                if (err.status === 500 || err.status === 404) {
                    alert("Server error, please refresh page. If problem persists, contact administrator.");
                }
            });
        }
        if (isJML || isSY) {
            this.props.fetchJmlTracking(this.props.salesOrderId).then((response) => {
                if (response.data) {
                    this.setState({ rows: response.data });
                }
            }, (err) => {
                if (err.status === 500 || err.status === 404) {
                    alert("Server error, please refresh page. If problem persists, contact administrator.");
                }
            });
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (data) => {
        let index = 0;
        let formatter = [];
        let trackString = "";
        if (data) {
            if (data.weights) {
                data.weights.map(r => {
                    formatter.push({ Idx: index, Package_Weight: r.weight, Package_Note: r.note, Package_Tracking: r.tracking });
                    if (!trackString) {
                        trackString += String(r.tracking);
                    } else {
                        trackString += ',' + String(r.tracking);
                    }
                    index++;
                })
            } else {
                formatter.push({ Idx: 0, Package_Weight: "", Package_Note: "", Package_Tracking: "" });
            }
        }
        this.setState({
            rows: formatter,
            selectedRows: null,
            editedRows: [],
            trackString,
        });
    }

    onTrackingNumRouter = (trackingNum) => {
        const url = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + trackingNum;
        let win = window.open(url);
        if (win != null) {
            win.focus();
        }
    };

    onTrackingNumRouterJML = (dependentValues) => {
        let url = '' + dependentValues.track_url;
        let win = window.open(url);
        if (win != null) {
            win.focus();
        }
    };

    trackAll = (e) => {
        e.preventDefault();
        const url = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + this.state.trackString;
        let win = window.open(url);
        if (win != null) {
            win.focus();
        }
    }

    jmlPrint = (e) => {
        e.preventDefault();
        this.props.jmlPrintLabel(this.props.salesOrderId);
        setTimeout(() => {
            this.props.fetchJmlTracking(this.props.salesOrderId).then((response) => {
                if (response.data) {
                    this.setState({ rows: response.data });
                }
            }, (err) => {
                if (err.status === 500 || err.status === 404) {
                    alert("Server error, please refresh page. If problem persists, contact administrator.");
                }
            });
          }, 7000);
    }

    renderTrackingTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const columns = isAFG ? [
            {
                key: 'Package_Tracking',
                name: <Translate value="tracking_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 200,
                formatter: ({ value }) => (
                    <div
                        style={{ width: '100%', height: '100%' }}
                        onDoubleClick={() => {
                            this.onTrackingNumRouter(value);
                        }}
                    >
                        {value}
                    </div>
                ),
            },
            {
                key: 'Package_Weight',
                name: <Translate value="weight_lbs" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 150,
            },
            {
                key: 'Package_Note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 350,
            },
        ] : [
            {
                key: 'tracking',
                name: <Translate value="tracking_num" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 325,
                formatter: ({ value, dependentValues }) => (
                    <div
                        style={{ width: '100%', height: '100%' }}
                        onDoubleClick={() => {
                            this.onTrackingNumRouterJML(dependentValues);
                        }}
                    >
                        {value}
                    </div>
                ),
                getRowMetaData: row => row,
            },
            // {
            //     key: 'service_code',
            //     name: <Translate value="service_code" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 325,
            // },
            {
                key: 'carrier_code',
                name: <Translate value="carrier_code" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 325,
            },
        ];

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '650px', marginLeft: '25px' }}>
                        <ReactDataGrid
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={150}
                            rowHeight={25}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <div>
                <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderTrackingTable()}
                        </span>
                    </Col>
                </Row>
                {isAFG &&
                    <Row className="centerStyle" style={{ marginTop: '15px' }}>
                        <Button
                            bsStyle="primary"
                            onClick={(e) => { this.trackAll(e); }}
                        >
                            <Translate value="track_all" />
                        </Button>
                    </Row>
                }
                {(isJML || isSY) &&
                    <Row className="centerStyle" style={{ marginTop: '15px' }}>
                        <Button
                            bsStyle="primary"
                            onClick={(e) => { this.jmlPrint(e); }}
                        >
                            <Translate value="print_new_label" />
                        </Button>
                    </Row>
                }
            </div>
        );
    }
}

export default SplitTrackingNumberModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/SplitTrackingNumberModal.jsx